export const FILE_TYPE_LABELS: {[key: string]: string} = {
  image : 'png, svg, jpeg',
  document: 'pdf, doc, docx',
  excel: 'xlsx',
  csv: 'csv'
};
